import React from "react";
import { Row, Col } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import RenderField from "../../../components/RenderField";
import { getEbookTranslations } from "../../../utils/getEbookTranslations";
import { getAudiobookTranslations } from "../../../utils/getAudiobookTranslations";
import { getPublicationFormTranslation } from "../../../utils/getPublicationFormTranslation";
import { getPrintedPublicationTranslations } from "../../../utils/getPrintedPublicationTranslations";
import { getDataCarrierVersionTranslations } from "../../../utils/getDataCarrierVersionTranslations";
export var WorkSpecSection = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var workSpec = _a.workSpec;
    var intl = useIntl();
    var formatMessage = intl.formatMessage;
    if (!workSpec)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(RenderField, { label: formatMessage({
                        id: "ui-br-publishers.publishers.workSpec.field.label.title",
                    }), value: workSpec.title }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(RenderField, { label: formatMessage({
                        id: "ui-br-publishers.publishers.workSpec.field.label.subTitle",
                    }), value: workSpec.subtitle }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(RenderField, { label: formatMessage({
                        id: "ui-br-publishers.publishers.workSpec.field.label.volumeNumber",
                    }), value: workSpec.volumeNumber }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(RenderField, { label: formatMessage({
                        id: "ui-br-publishers.publishers.workSpec.field.label.partName",
                    }), value: workSpec.partTitle }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement("h3", null,
                    React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.workSpec.title.authors" })))), (_b = workSpec.authors) === null || _b === void 0 ? void 0 :
        _b.map(function (author, index) { return (React.createElement(Row, { key: index },
            React.createElement(Col, { xs: 4 },
                React.createElement(RenderField, { label: formatMessage({
                        id: "ui-br-publishers.publishers.workSpec.field.label.authors.firstName",
                    }), value: author.firstName })),
            React.createElement(Col, { xs: 4 },
                React.createElement(RenderField, { label: formatMessage({
                        id: "ui-br-publishers.publishers.workSpec.field.label.authors.lastName",
                    }), value: author.lastName })),
            author.personId && author.sourceId && (React.createElement(Col, { xs: 4 },
                React.createElement(RenderField, { label: formatMessage({
                        id: "ui-br-publishers.publishers.workSpec.field.label.authors.sourceId",
                    }), value: author.sourceId }))))); }),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 6 },
                React.createElement(RenderField, { label: formatMessage({
                        id: "ui-br-publishers.publishers.workSpec.datePicker.label.publicationDate",
                    }), value: workSpec.publicationDate })),
            React.createElement(Col, { xs: 6 },
                React.createElement(RenderField, { label: formatMessage({
                        id: "ui-br-publishers.publishers.workSpec.field.label.releaseOrder",
                    }), value: workSpec.editionNumber }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(RenderField, { label: formatMessage({
                        id: "ui-br-publishers.publishers.workSpec.field.label.publishedInConjunction",
                    }), value: workSpec.coEditionWith }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(RenderField, { label: formatMessage({
                        id: "ui-br-publishers.publishers.workSpec.select.label.publicationForm",
                    }), value: getPublicationFormTranslation(intl, workSpec.publicationForm) }))),
        workSpec.publicationForm === "PRINT" && (React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(RenderField, { label: formatMessage({
                        id: "ui-br-publishers.publishers.workSpec.select.label.printedPublicationBinding",
                    }), value: (_d = (_c = workSpec.publicationType) === null || _c === void 0 ? void 0 : _c.printedPublications) === null || _d === void 0 ? void 0 : _d.map(function (binding) {
                        return getPrintedPublicationTranslations(intl, binding);
                    }).join(", ") })))),
        workSpec.publicationForm === "EBOOK" && (React.createElement(React.Fragment, null,
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12 },
                    React.createElement(RenderField, { label: formatMessage({
                            id: "ui-br-publishers.publishers.workSpec.select.label.ebookFormats",
                        }), value: (_e = workSpec.eBookFormats) === null || _e === void 0 ? void 0 : _e.map(function (format) { return getEbookTranslations(intl, format); }).join(", ") }))),
            workSpec.otherFormats && workSpec.otherFormats.length > 0 && (React.createElement(Row, null,
                React.createElement(Col, { xs: 12 },
                    React.createElement("h3", null,
                        React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.workSpec.select.label.ebookFormats.other" }))),
                workSpec.otherFormats.map(function (otherFormat, index) { return (React.createElement(Col, { xs: 12, key: index },
                    React.createElement(RenderField, { label: formatMessage({
                            id: "ui-br-publishers.publishers.workSpec.select.label.ebookFormats.otherFormat",
                        }), value: otherFormat.format }))); }))))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 6 },
                React.createElement(RenderField, { label: formatMessage({
                        id: "ui-br-publishers.publishers.workSpec.select.label.dataCarrierVersions",
                    }), value: (_f = workSpec.dataCarrierVersions) === null || _f === void 0 ? void 0 : _f.map(function (version) {
                        return getDataCarrierVersionTranslations(intl, version);
                    }).join(", ") })),
            React.createElement(Col, { xs: 6 },
                React.createElement(RenderField, { label: formatMessage({
                        id: "ui-br-publishers.publishers.workSpec.select.label.audioBookFormats",
                    }), value: (_g = workSpec.audioBookFormats) === null || _g === void 0 ? void 0 : _g.map(function (format) { return getAudiobookTranslations(intl, format); }).join(", ") })))));
};
